import React, { useEffect, useState } from "react";
import { API, graphqlOperation } from "aws-amplify";
import {
  listCompanyJobDescriptions,
  listCompanyProfiles,
} from "../../graphql/queries";
import JobPostDetails from "./JobPostDetails";
import JobPostForm from "./JobPostForm";
import Header from "../../components/header/Header";
import { Link } from "react-router-dom";
import {
  updateCompanyProfile,
  createPrivateScreening,
  deleteCompanyJobDescription,
  createInterviewSlot,
} from "../../graphql/mutations";
import BuyPremium from "../../components/company/BuyPremium";
import { useNavigate } from "react-router-dom";
import { createPublicInterviewUrl, TOKEN_STATUS } from "../../utils/tokenUtils";
import { findOrCreateCandidateProfile, createMeetingConfig } from "../../utils/candidateUtils";

const JobDetailsList = () => {
  const [jobDetails, setJobDetails] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [company, setCompany] = useState({});
  const [companyemail, setCompanyemail] = useState("");
  const [companyID, setCompanyID] = useState("");
  const [nextToken, setNextToken] = useState(null);
  const [companyList, setCompanyList] = useState([]);
  const [companyjobcount, setcompanyjobcount] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
  const CompanyEmailID = localStorage.getItem("CompanyEmailID");

  const [loading, setLoading] = useState(true);
  const [isSending, setIsSending] = useState(false);

  const [point, setPoint] = useState(0);
  const [reming, setReming] = useState({
    remainingCredit: point,
  });

  const [showPrivateScreeningModal, setShowPrivateScreeningModal] =
    useState(false);

  // Sign-in-less interview states
  const [showSignInLessModal, setShowSignInLessModal] = useState(false);
  const [isGeneratingLink, setIsGeneratingLink] = useState(false);
  const [generatedLink, setGeneratedLink] = useState("");
  const [showLinkModal, setShowLinkModal] = useState(false);
  const [linkGenerationError, setLinkGenerationError] = useState("");

  // Demo interview states
  const [showDemoModal, setShowDemoModal] = useState(false);
  const [isGeneratingDemoLink, setIsGeneratingDemoLink] = useState(false);
  const [generatedDemoLink, setGeneratedDemoLink] = useState("");
  const [showDemoLinkModal, setShowDemoLinkModal] = useState(false);
  const [demoLinkGenerationError, setDemoLinkGenerationError] = useState("");
  const [selectedMockJD, setSelectedMockJD] = useState(null);

  // 🧪 Mock Job Descriptions for Demo Testing
  const MOCK_JOB_DESCRIPTIONS = [
    {
      id: 'mock-jd-frontend',
      jobTitle: 'Senior Frontend Developer',
      jobDescription: `We are looking for an experienced Senior Frontend Developer to join our team. You will be responsible for building and maintaining user-facing features using modern JavaScript frameworks. Key responsibilities include developing responsive web applications, collaborating with designers and backend developers, optimizing applications for maximum speed and scalability, and mentoring junior developers.`,
      skill: 'React, TypeScript, JavaScript, HTML5, CSS3, Redux, REST APIs, Git, Agile/Scrum',
      selectedCategory: 'Engineering',
      selectedExperience: '4-6 years'
    },
    {
      id: 'mock-jd-backend',
      jobTitle: 'Backend Engineer (Python)',
      jobDescription: `Join our backend team to design and implement scalable server-side solutions. You will work on building robust APIs, database design, and system architecture. Responsibilities include developing RESTful APIs, optimizing database queries, implementing security best practices, and working with cloud services like AWS or GCP.`,
      skill: 'Python, Django/Flask, PostgreSQL, Redis, Docker, AWS, REST APIs, Microservices',
      selectedCategory: 'Engineering',
      selectedExperience: '3-5 years'
    },
    {
      id: 'mock-jd-fullstack',
      jobTitle: 'Full Stack Developer',
      jobDescription: `We need a versatile Full Stack Developer who can work across the entire technology stack. You will be building features from database to UI, participating in code reviews, and contributing to architectural decisions. The ideal candidate is comfortable with both frontend and backend technologies.`,
      skill: 'Node.js, React, MongoDB, Express, JavaScript, TypeScript, GraphQL, Docker',
      selectedCategory: 'Engineering',
      selectedExperience: '2-4 years'
    },
    {
      id: 'mock-jd-data-scientist',
      jobTitle: 'Data Scientist',
      jobDescription: `We are seeking a Data Scientist to analyze large datasets and build predictive models. You will work closely with product and engineering teams to derive insights and implement machine learning solutions. Responsibilities include data analysis, model development, A/B testing, and presenting findings to stakeholders.`,
      skill: 'Python, Machine Learning, SQL, TensorFlow/PyTorch, Pandas, Statistics, Data Visualization',
      selectedCategory: 'Data Science',
      selectedExperience: '3-5 years'
    },
    {
      id: 'mock-jd-devops',
      jobTitle: 'DevOps Engineer',
      jobDescription: `Join our DevOps team to build and maintain CI/CD pipelines, manage cloud infrastructure, and ensure system reliability. You will automate deployment processes, monitor system performance, and implement security best practices. Experience with containerization and orchestration is essential.`,
      skill: 'AWS/Azure, Kubernetes, Docker, Terraform, Jenkins/GitLab CI, Linux, Monitoring Tools',
      selectedCategory: 'Engineering',
      selectedExperience: '3-5 years'
    },
    {
      id: 'mock-jd-product-manager',
      jobTitle: 'Product Manager',
      jobDescription: `We are looking for a Product Manager to lead product strategy and roadmap. You will work with cross-functional teams to define product vision, gather requirements, and prioritize features. Responsibilities include market research, user interviews, writing PRDs, and coordinating with engineering and design teams.`,
      skill: 'Product Strategy, Agile, User Research, Data Analysis, Roadmapping, Stakeholder Management',
      selectedCategory: 'Product',
      selectedExperience: '4-6 years'
    },
    {
      id: 'mock-jd-ui-designer',
      jobTitle: 'UI/UX Designer',
      jobDescription: `We need a creative UI/UX Designer to create intuitive and visually appealing user interfaces. You will conduct user research, create wireframes and prototypes, and collaborate with developers to implement designs. Strong portfolio demonstrating design thinking and problem-solving is required.`,
      skill: 'Figma, Sketch, Adobe XD, User Research, Wireframing, Prototyping, Design Systems',
      selectedCategory: 'Design',
      selectedExperience: '2-4 years'
    },
    {
      id: 'mock-jd-qa-engineer',
      jobTitle: 'QA Engineer',
      jobDescription: `Join our Quality Assurance team to ensure software quality through manual and automated testing. You will create test plans, write test cases, perform regression testing, and work with developers to identify and fix bugs. Experience with automation frameworks is a plus.`,
      skill: 'Manual Testing, Selenium, Jest, Test Planning, Bug Tracking, API Testing, Agile',
      selectedCategory: 'Engineering',
      selectedExperience: '2-4 years'
    }
  ];

  const navigate = useNavigate();
  useEffect(() => {
    const companyProfileID = localStorage.getItem("CompanyProfileID");
    if (companyProfileID) {
      fetchJobDetails(companyProfileID);
    }
  }, []);

  const closeModal = () => {
    console.log("Closing modal");
    setIsModalOpen(false);
  };
  const handleProfileClickOpen = () => {
    setIsProfileModalOpen(true);
  };
  const handleProfileClickClose = () => {
    setIsProfileModalOpen(false);
  };
  useEffect(() => {
    const storedCompanyEmail = localStorage.getItem("CompanyEmailID");
    const storedCompanyID = localStorage.getItem("CompanyProfileID");

    setCompany(storedCompanyEmail);
    setCompanyID(storedCompanyID);

    const fetchData = async () => {
      try {
        const candidateProfileEmailID = localStorage.getItem(
          "candidateProfileEmailID"
        );
        setCompanyemail(candidateProfileEmailID);

        if (!candidateProfileEmailID) {
          // Handle case where candidate email is not found
          return;
        }

        const { data } = await API.graphql(
          graphqlOperation(listCompanyProfiles, {
            filter: {
              email: { eq: candidateProfileEmailID },
            },
            limit: 100, // Limit the number of items per page, adjust as needed
            nextToken: nextToken, // Pass nextToken if available
          })
        );

        if (
          data &&
          data.listCompanyProfiles.items &&
          data.listCompanyProfiles.items.length > 0
        ) {
          const companyData = data.listCompanyProfiles.items[0];
          setCompany(companyData);
          setPoint(companyData.remainingCredit);

          // Save company email and ID to local storage

          // Note: company and companyID won't have the updated values immediately after setCompany/setCompanyID

          const { items, nextToken: newNextToken } = data.listCompanyProfiles;
          setCompanyList((prevList) => [...prevList, ...items]);
          setNextToken(newNextToken);
          setLoading(false);
        } else {
          setLoading(false); // Set loading to false if no data is found
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        // Handle error
        setLoading(false); // Set loading to false on error
      }
    };

    fetchData();

    // fetching job description count code start

    // const fetchJobCount = async() => {

    //   const storedCompanyID = localStorage.getItem("CompanyProfileID");

    //   // Fetch user profile with pagination
    //   let nextToken = null;
    //   let userProfileList = [];
    //   do {
    //     const joblistResponse  = await API.graphql(
    //       graphqlOperation(listCompanyJobDescriptions, {
    //         filter: { companyProfileID: { eq: storedCompanyID } },
    //         limit: 100,
    //         nextToken: nextToken,
    //       })
    //     );
    //     console.log("####################### from job details list###############3",joblistResponse)
    //     userProfileList.push(
    //       ...joblistResponse.data.listCompanyProfiles.items
    //     );
    //     nextToken = joblistResponse.data.listCompanyProfiles.nextToken;
    //   } while (nextToken);

    //   // Set compnay count
    //   // if (userProfileList.length > 0) {
    //   //   // setUserFullName(userProfileList[0].fullName);
    //   //   setcompanyjobcount(true)

    //   // } else {
    //   //   console.log("User profile not found.");
    //   //   setcompanyjobcount(false)
    //   // }

    // }

    // fetchJobCount()

    const fetchJobCount = async () => {
      const storedCompanyID = localStorage.getItem("CompanyProfileID");

      try {
        let nextToken = null;
        let jobCount = 0;

        do {
          const jobListResponse = await API.graphql(
            graphqlOperation(listCompanyJobDescriptions, {
              filter: { companyProfileID: { eq: storedCompanyID } },
              limit: 100,
              nextToken: nextToken,
            })
          );

          const jobDescriptions =
            jobListResponse.data.listCompanyJobDescriptions.items;
          jobCount += jobDescriptions.length;

          nextToken = jobListResponse.data.listCompanyJobDescriptions.nextToken;
        } while (nextToken);

        // Set company count
        if (jobCount > 0) {
          // You can set company job count here
          setcompanyjobcount(true);
        } else {
          console.log("No job descriptions found for the company.");
          setcompanyjobcount(false);
        }
      } catch (error) {
        console.error("Error fetching job count:", error);
        // Handle error appropriately
      }
    };

    fetchJobCount();

    // fetching job description count code end
  }, [nextToken]);

  console.log("compay count", companyjobcount);

  const fetchJobDetails = async (companyProfileID) => {
    try {
      let nextToken = null;
      const allJobDetails = [];

      // Fetch data with pagination
      do {
        const response = await API.graphql(
          graphqlOperation(listCompanyJobDescriptions, {
            filter: { companyProfileID: { eq: companyProfileID } },
            limit: 100, // Adjust the limit as needed
            nextToken: nextToken,
          })
        );
        const { items, nextToken: newToken } =
          response.data.listCompanyJobDescriptions;
        allJobDetails.push(...items);
        nextToken = newToken;
      } while (nextToken);

      // Format the date fields
      const jobDetailsData = allJobDetails.map((job) => ({
        ...job,
        createdAt: new Date(job.createdAt).toLocaleString(),
        updatedAt: new Date(job.updatedAt).toLocaleString(),
      }));

      setJobDetails(jobDetailsData);
    } catch (error) {
      console.error("Error fetching job details:", error);
    }
  };

  const handleViewDetails = (job) => {
    setSelectedJob(job);
    setShowModal(true);
    setIsEditMode(false);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedJob(null);
    setIsEditMode(false);
    setShowPrivateScreeningModal(false);
  };

  const handleEditJob = () => {
    setIsEditMode(true);
  };

  const handlePrivateScreeningMail = () => {
    setShowPrivateScreeningModal(true);
  };  const handlePrivateScreeningMailSubmit = async (e) => {
    e.preventDefault(); // Prevent default form submission behavior

    if (CompanyEmailID !== "hr@varahitechnologies.com" && point < 200) {
      alert("You need at least 200 points to send a mail and Buy Premium.");
      handleCloseModal();
      setIsModalOpen(true); // Open modal if point is less than 200
      console.log(`isModalOpen`, isModalOpen); // Log the state of isModalOpen
      return; // Exit the function
    }

    // If point is 200 or greater, proceed to extract candidate info from the form
    const candidateName = e.target.elements.candidateName.value;
    const candidateEmail = e.target.elements.candidateEmail.value;
    
    try {
      console.log('🏢 Company Portal: Starting private screening process');
      
      // Step 1: Find or create candidate profile using shared utility
      const {
        candidateProfile,
        candidateProfileID,
        isExistingCandidate
      } = await findOrCreateCandidateProfile(candidateName, candidateEmail);

      console.log('✅ Candidate profile resolved:', {
        id: candidateProfileID,
        existing: isExistingCandidate,
        name: candidateProfile.fullName,
        email: candidateProfile.email
      });

      // Step 2: Create interview slot with simplified meeting config
      let interviewLink = null;
      try {
        const interviewSlotInput = {
          candidateProfileID: candidateProfileID,
          candidateEmail: candidateProfile.email,
          date: new Date().toISOString().split('T')[0], // Today's date
          startTime: '09:00',
          endTime: '10:00',
          status: TOKEN_STATUS.ACTIVE, // Use SCHEDULED status for active interviews
          meetingLinkURL: '', // This can be empty for now
          meetingConfig: createMeetingConfig({
            companyID: companyID || 'unknown',
            companyName: company?.companyName || 'Company',
            jobTitle: selectedJob.jobTitle,
            jdID: selectedJob.id,
            interviewType: 'company-portal',
            candidateName: candidateName,
            numberOfQuestions: 5 // Default for private screening invitations
          }),
          candidateAttendance: false,
          botAttendance: false,
          jdID: selectedJob.id, // Use the actual job ID
          candidateProfileInterviewSlotsId: candidateProfileID // Establish relationship
        };

        console.log('📝 Creating interview slot with input:', interviewSlotInput);

        // Create the interview slot
        const createResponse = await API.graphql(
          graphqlOperation(createInterviewSlot, { input: interviewSlotInput })
        );

        console.log('📋 Interview slot creation response:', createResponse);

        if (createResponse.data && createResponse.data.createInterviewSlot) {
          // Generate the public link using interview slot ID as token
          const interviewSlotId = createResponse.data.createInterviewSlot.id;
          interviewLink = createPublicInterviewUrl(interviewSlotId);
          console.log('🔗 Generated interview link:', interviewLink);
        } else {
          console.error('❌ Failed to create interview slot - no data returned');
        }
      } catch (linkError) {
        console.error('❌ Error generating interview link:', linkError);
        console.error('GraphQL Errors:', linkError.errors);
        // Continue with email without link if generation fails
      }

      // Step 3: Send invitation email (with or without interview link)
      const emailSent = await sendPrivateScreeningInvitationEmail(
        candidateName,
        candidateEmail,
        interviewLink // Pass the interview link to email function
      );

      if (emailSent) {
        // If email sent successfully, create private screening invitation
        await createPrivateScreeningInvitation(candidateName, candidateEmail);

        console.log("✅ Email sent and private screening created successfully");
        e.target.reset(); // Reset the form
      } else {
        console.error("❌ Email sending failed, skipping further steps.");
      }
    } catch (error) {
      console.error("❌ Error creating private screening:", error);
    }
  };

  //   const sendPrivateScreeningInvitationEmail = async (
  //     candidateName,
  //     candidateEmail
  //   ) => {
  //     const sesClient = new SESClient({
  //       region: "ap-south-1",
  //       credentials: {
  //         accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
  //         secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
  //       },
  //       // credentials: {
  //       //   accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
  //       //   secretAccessKey: process.env.EACT_APP_AWS_SECRET_ACCESS_KEY,
  //       // },
  //     });

  //     const emailParams = {
  //       Source: "getscreened@varahitechnologies.com",
  //       Destination: {
  //         ToAddresses: [candidateEmail],
  //       },
  //       Message: {
  //         Subject: {
  //           Data: `Congratulations! You've been selected for the screening round for the position of ${selectedJob.jobTitle} at ${company.companyName}.`,
  //         },
  //         Body: {
  //           Text: {
  //             Data: `Dear ${candidateName},

  // Greetings of the Day!
  // I am delighted to inform you that you have been selected for further consideration for the position of ${selectedJob.jobTitle} at ${company.companyName}. Here are some details about the job:

  // Job Title: ${selectedJob.jobTitle}
  // Category: ${selectedJob.selectedCategory}
  // Experience Required: ${selectedJob.selectedExperience}
  // Compensation: ${selectedJob.compensation}
  // Benefits: ${selectedJob.benefits}
  // Skills Required: ${selectedJob.skill}
  // Job Description:
  // ${selectedJob.jobDescription}

  // To streamline the process, we have set up an online portal for the interview. You can access the interview portal using the following link: https://www.getscreened.in. We have also provided a YouTube video for your reference: https://www.youtube.com/watch?si=r94pgS7GIIy-p6j-&v=3rMe3qx9Amc&feature=youtu.be.
  // Please select a suitable time slot from the available options in the portal. If none of the provided time work for you,  we will do our best to accommodate your schedule, and will reach out to you shortly to schedule the interview. Please let us know if you are available for a private screening interview.

  // Best regards,
  //  ${company.contactPersonDesignation}
  //  ${company.contactPersonName}
  //  ${company.contactPersonNumber}
  //  ${company.email}
  //  ${company.companyUrl}`,
  //           },
  //         },
  //       },
  //     };

  //     const sendEmailCommand = new SendEmailCommand(emailParams);
  //     await sesClient.send(sendEmailCommand);
  //     handleCloseModal();
  //   };
  const sendPrivateScreeningInvitationEmail = async (candidateName, candidateEmail, interviewLink = null) => {
    setIsSending(true);
    const subject = `Congratulations! You've been selected for the screening round for the position of ${selectedJob.jobTitle} at ${company.companyName}.`;
    
    // Create email body with or without interview link
    let emailBody = `
    <p>Dear ${candidateName},</p>
    <p>Greetings of the Day!</p>
    <p>I am delighted to inform you that you have been selected for further consideration for the position of <strong>${selectedJob.jobTitle}</strong> at <strong>${company.companyName}</strong>. Here are some details about the job:</p>
    <ul>
      <li><strong>Job Title:</strong> ${selectedJob.jobTitle}</li>
      <li><strong>Category:</strong> ${selectedJob.selectedCategory}</li>
      <li><strong>Experience Required:</strong> ${selectedJob.selectedExperience}</li>
      <li><strong>Compensation:</strong> ${selectedJob.compensation}</li>
      <li><strong>Benefits:</strong> ${selectedJob.benefits}</li>
      <li><strong>Skills Required:</strong> ${selectedJob.skill}</li>
    </ul>
    <p><strong>Job Description:</strong><br>${selectedJob.jobDescription.replace(
      /\n/g,
      "<br>"
    )}</p>`;

    // Add interview link section if available
    if (interviewLink) {
      emailBody += `
      <div style="background-color: #f0f9ff; border: 2px solid #3b82f6; border-radius: 8px; padding: 16px; margin: 20px 0;">
        <h3 style="color: #1e40af; margin-top: 0;">🎉 Direct Interview Access</h3>
        <p style="margin: 10px 0;">We've prepared a special interview link just for you! Click the button below to start your interview immediately - no registration required.</p>
        <div style="text-align: center; margin: 20px 0;">
          <a href="${interviewLink}" 
             style="background-color: #3b82f6; color: white; padding: 12px 24px; text-decoration: none; border-radius: 6px; font-weight: bold; display: inline-block;">
            🚀 Start Your Interview Now
          </a>
        </div>
        <p style="font-size: 14px; color: #6b7280; margin-bottom: 0;">
          <strong>Note:</strong> This link is unique to you and can only be used once. Please ensure you're ready before clicking.
        </p>
      </div>`;
    }

    // Continue with the rest of the email content
    emailBody += `
    <p>To learn more about our interview process, we have also provided a YouTube video for your reference: <a href="https://www.youtube.com/watch?si=r94pgS7GIIy-p6j-&v=3rMe3qx9Amc&feature=youtu.be">YouTube Video</a>.</p>
    ${!interviewLink ? '<p>If you need to schedule a different time or have any questions, please reach out to us.</p>' : ''}
    <p>Best regards,<br>
    ${company.contactPersonDesignation}<br>
    ${company.contactPersonName}<br>
    ${company.contactPersonNumber}<br>
    <a href="mailto:${company.email}">${company.email}</a><br>
    <a href="${company.companyUrl}">${company.companyUrl}</a></p>
  `;

    const myHeaders = new Headers();
    // myHeaders.append("X-Api-Key", process.env.REACT_APP_API_KEY);
    myHeaders.append("X-Api-Key", "abce-124");
    myHeaders.append("Content-Type", "application/json");    const raw = JSON.stringify({
      subject: subject,
      body: emailBody,
      to: candidateEmail,
      fromEmail: company.email,
      fromName: company.contactPersonName,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        "https://pharmaclick.co.in/RazorPay/WeatherForecast/sendEmailSES",
        requestOptions
      );
      const result = await response.json(); // Parse the response as JSON

      if (result.message === "Invalid API Key") {
        console.error("Invalid API Key");
        return false;
      }

      if (
        result.message ===
        "The SMTP server requires a secure connection or the client was not authenticated. The server response was: 5.7.0 Authentication Required. For more information, go to"
      ) {
        console.log("SMTP Problem");
        return false;
      }

      console.log(result);
      handleCloseModal();
      return true;
    } catch (error) {
      console.error("Error sending email:", error);
      return false;
    } finally {
      setIsSending(false);
    }
  };

  const createPrivateScreeningInvitation = async (
    candidateName,
    candidateEmail
  ) => {
    try {
      // Update company point
      const updateSuccess = await updateCompanyPoint();

      if (updateSuccess) {
        // Proceed with creating the private screening

        // Call createPrivateScreening mutation
        const createPrivateScreeningInput = {
          companyProfileID: companyID,
          jobDescription: selectedJob.jobTitle,
          candidateName: candidateName,
          candidateEmail: candidateEmail,
          jdID: selectedJob.id,
          pointsDeducted: 200,
        };

        const createPrivateScreeningResult = await API.graphql(
          graphqlOperation(createPrivateScreening, {
            input: createPrivateScreeningInput,
          })
        );

        if (createPrivateScreeningResult.data.createPrivateScreening) {
          console.log("Private screening created successfully");
        } else {
          console.error("Failed to create private screening");
        }
      } else {
        console.error("Failed to update company point");
      }
    } catch (error) {
      console.error("Error creating private screening:", error);
      throw error; // Rethrow the error to be handled in handlePrivateScreeningMailSubmit
    }
  };
  const updateCompanyPoint = async () => {
    try {
      // Declare variables
      let candidateProfileEmailID, data, companyData, items, newNextToken;

      // Fetch candidate profile email ID from local storage
      candidateProfileEmailID = localStorage.getItem("candidateProfileEmailID");
      setCompanyemail(candidateProfileEmailID);

      // Check if candidate email is available
      if (!candidateProfileEmailID) {
        // Handle case where candidate email is not found
        return false;
      }

      let currentRemainingCredit = point;
      let updatedRemainingCredit = currentRemainingCredit - 200;

      setPoint(updatedRemainingCredit);

      const updateInput = {
        id: company.id, // Assuming you have the company ID available
        remainingCredit: updatedRemainingCredit,
      };

      // Fetch company profiles data
      const result = await API.graphql(
        graphqlOperation(updateCompanyProfile, {
          input: updateInput,
        })
      );

      console.log("GraphQL Result:", result);

      // Destructure data from result
      data = result.data;

      // Check if data is available
      if (data && data.updateCompanyProfile) {
        // Extract company data
        companyData = data.updateCompanyProfile;
        setCompany(companyData);
        setPoint(companyData.remainingCredit);

        console.log("Company Data:", companyData);

        setLoading(false);
        return true; // Return true for success
      } else {
        console.error("No data returned or invalid response structure:", data);
        setLoading(false); // Set loading to false if no data is found
        return false; // Return false for failure
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      // Handle error
      setLoading(false); // Set loading to false on error
      return false; // Return false for failure
    }
  };
  const handleDeleteJob = async (jobId, jobTitle) => {
    const isConfirmed = window.confirm(
      `Are you sure you want to delete the job titled "${jobTitle}"?`
    );
    if (!isConfirmed) {
      return; // Exit the function if the user cancels the deletion
    }

    try {
      await API.graphql(
        graphqlOperation(deleteCompanyJobDescription, { input: { id: jobId } })
      );
      setJobDetails((prevJobDetails) =>
        prevJobDetails.filter((job) => job.id !== jobId)
      );
      console.log("Job deleted successfully");
    } catch (error) {
      console.error("Error deleting job:", error);
    }
  };

  // Sign-in-less interview functions
  const handleSignInLessInterview = (job) => {
    setSelectedJob(job);
    setShowSignInLessModal(true);
  };

  // Demo interview functions
  const handleDemoInterview = (job) => {
    setSelectedJob(job);
    setSelectedMockJD(null); // Reset mock JD selection
    setShowDemoModal(true);
  };

  // 🧪 Standalone demo (without a real job selected)
  const handleStandaloneDemoInterview = () => {
    setSelectedJob(null);
    setSelectedMockJD(MOCK_JOB_DESCRIPTIONS[0]); // Default to first mock JD
    setShowDemoModal(true);
  };

  const generateDemoLink = async (candidateName, candidateEmail) => {
    // 🎯 For demo: only name is optional, email is optional (use placeholder)
    // 🧪 Use mock JD if selected, otherwise fall back to selectedJob
    const jobSource = selectedMockJD || selectedJob;
    
    if (!jobSource) {
      setDemoLinkGenerationError('Please select a Job Description');
      return;
    }

    setIsGeneratingDemoLink(true);
    setDemoLinkGenerationError('');

    // Use placeholder values if not provided
    const demoEmail = candidateEmail?.trim() || `demo-${Date.now()}@demo.getscreened.in`;
    const demoName = candidateName?.trim() || 'Demo Candidate';

    try {
      console.log('🎯 Demo: Starting simple demo link generation (no profiles)');
      console.log('📋 Using job source:', selectedMockJD ? 'Mock JD' : 'Real Job', jobSource?.jobTitle);
      console.log('👤 Demo candidate:', { name: demoName, email: demoEmail, isPlaceholder: !candidateEmail?.trim() });
      
      // 📝 Create interview slot without any candidate profile
      const interviewSlotInput = {
        candidateProfileID: 'demo-no-profile', // Placeholder ID
        candidateEmail: demoEmail,
        date: new Date().toISOString().split('T')[0], // Today's date
        startTime: '09:00',
        endTime: '10:00',
        status: TOKEN_STATUS.ACTIVE,
        meetingLinkURL: '', // Empty for now
        meetingConfig: createMeetingConfig({
          companyID: companyID || 'demo-company',
          companyName: company?.companyName || 'Demo Company',
          jobTitle: jobSource?.jobTitle || 'Demo Position',
          jdID: jobSource?.id || 'demo-jd',
          interviewType: 'demo',
          candidateName: null, // 🚫 Don't store candidate name in config
          numberOfQuestions: 4, // Fixed 4 questions for demo
          isDemo: true,
          // 📋 Add job data for backend to generate relevant questions
          jobData: {
            jobDescription: jobSource?.jobDescription || null,
            skills: jobSource?.skill || null,
            category: jobSource?.selectedCategory || null,
            experienceLevel: jobSource?.selectedExperience || null
          }
        }),
        candidateAttendance: false,
        botAttendance: false,
        jdID: jobSource?.id || 'demo-job',
        candidateProfileInterviewSlotsId: 'demo-no-profile' // Placeholder
      };

      console.log('📝 Creating demo interview slot (profile-less):', {
        email: candidateEmail,
        isDemo: true,
        profileRequired: false,
        jobData: interviewSlotInput.meetingConfig
      });

      // 💾 Create the interview slot
      const createResponse = await API.graphql(
        graphqlOperation(createInterviewSlot, { input: interviewSlotInput })
      );

      console.log('📋 Demo interview slot creation response:', createResponse);

      if (createResponse.data.createInterviewSlot) {
        // Use the generated ID as the access token
        const interviewSlotId = createResponse.data.createInterviewSlot.id;
        const publicLink = createPublicInterviewUrl(interviewSlotId);
        
        console.log('🎉 Successfully created demo interview slot (no profile needed):', {
          slotId: interviewSlotId,
          candidateEmail: candidateEmail,
          isDemo: true,
          profileLess: true,
          publicLink: publicLink,
          usedMockJD: !!selectedMockJD
        });
        
        setGeneratedDemoLink(publicLink);
        setShowDemoLinkModal(true);
        setShowDemoModal(false);
        setSelectedMockJD(null); // Reset for next time
      } else {
        console.error('❌ Failed to create demo interview slot - no data returned');
        setDemoLinkGenerationError('Failed to create demo interview slot');
      }
    } catch (error) {
      console.error('Error generating demo link:', error);
      // Log the actual error for debugging
      if (error.errors && error.errors.length > 0) {
        console.error('GraphQL Errors:', error.errors);
        setDemoLinkGenerationError(`Error: ${error.errors[0].message}`);
      } else if (error.data && error.data.errors) {
        console.error('GraphQL Errors in data:', error.data.errors);
        setDemoLinkGenerationError(`Error: ${error.data.errors[0].message}`);
      } else {
        setDemoLinkGenerationError('Failed to generate demo interview link. Please try again.');
      }
    } finally {
      setIsGeneratingDemoLink(false);
    }
  };
  const generateSignInLessLink = async (candidateName, candidateEmail, numberOfQuestions = 5) => {
    if (!candidateName || !candidateEmail) {
      setLinkGenerationError('Please provide both candidate name and email');
      return;
    }

    setIsGeneratingLink(true);
    setLinkGenerationError('');

    try {
      console.log('🔗 Sign-in-less: Starting link generation process');
      console.log(`📝 Number of questions selected: ${numberOfQuestions}`);
      
      // Step 1: Find or create candidate profile using shared utility
      const {
        candidateProfile,
        candidateProfileID,
        isExistingCandidate
      } = await findOrCreateCandidateProfile(candidateName, candidateEmail);

      console.log('✅ Candidate profile resolved for sign-in-less:', {
        id: candidateProfileID,
        existing: isExistingCandidate,
        name: candidateProfile.fullName,
        email: candidateProfile.email,
        userID: candidateProfile.userID
      });      // Step 2: Create interview slot with simplified meeting config
      const interviewSlotInput = {
        candidateProfileID: candidateProfileID,
        candidateEmail: candidateProfile.email,
        date: new Date().toISOString().split('T')[0], // Today's date
        startTime: '09:00',
        endTime: '10:00',
        status: TOKEN_STATUS.ACTIVE,
        meetingLinkURL: '', // This can be empty for now
        meetingConfig: createMeetingConfig({
          companyID: companyID || 'unknown',
          companyName: company?.companyName || 'Company',
          jobTitle: selectedJob?.jobTitle || 'Position',
          jdID: selectedJob?.id,
          interviewType: 'sign-in-less',
          candidateName: candidateName,
          numberOfQuestions: numberOfQuestions // ← Add number of questions
        }),
        candidateAttendance: false,
        botAttendance: false,
        jdID: selectedJob.id, // Use the actual job ID
        candidateProfileInterviewSlotsId: candidateProfileID // Establish relationship
      };

      console.log('📝 Creating interview slot for sign-in-less with input:', interviewSlotInput);

      // Create the interview slot
      const createResponse = await API.graphql(
        graphqlOperation(createInterviewSlot, { input: interviewSlotInput })
      );

      console.log('📋 Interview slot creation response:', createResponse);

      if (createResponse.data.createInterviewSlot) {
        // Use the generated ID as the access token
        const interviewSlotId = createResponse.data.createInterviewSlot.id;
        const publicLink = createPublicInterviewUrl(interviewSlotId);
        
        console.log('🎉 Successfully created sign-in-less interview slot:', {
          slotId: interviewSlotId,
          candidateProfileID: candidateProfileID,
          candidateEmail: candidateProfile.email,
          isExistingCandidate: isExistingCandidate,
          publicLink: publicLink
        });
        
        setGeneratedLink(publicLink);
        setShowLinkModal(true);
        setShowSignInLessModal(false);
      } else {
        console.error('❌ Failed to create interview slot - no data returned');
        setLinkGenerationError('Failed to create interview slot');
      }    } catch (error) {
      console.error('Error generating sign-in-less link:', error);
      // Log the actual error for debugging
      if (error.errors && error.errors.length > 0) {
        console.error('GraphQL Errors:', error.errors);
        setLinkGenerationError(`Error: ${error.errors[0].message}`);
      } else if (error.data && error.data.errors) {
        console.error('GraphQL Errors in data:', error.data.errors);
        setLinkGenerationError(`Error: ${error.data.errors[0].message}`);
      } else {
        setLinkGenerationError('Failed to generate interview link. Please try again.');
      }
    } finally {
      setIsGeneratingLink(false);
    }
  };

  const copyLinkToClipboard = () => {
    navigator.clipboard.writeText(generatedLink);
    alert('Link copied to clipboard!');
  };

  const closeLinkModal = () => {
    setShowLinkModal(false);
    setGeneratedLink('');
    setLinkGenerationError('');
  };

  const closeSignInLessModal = () => {
    setShowSignInLessModal(false);
    setLinkGenerationError('');
  };

  const closeDemoModal = () => {
    setShowDemoModal(false);
    setDemoLinkGenerationError('');
  };

  const closeDemoLinkModal = () => {
    setShowDemoLinkModal(false);
    setGeneratedDemoLink('');
  };

  const copyDemoLinkToClipboard = () => {
    navigator.clipboard.writeText(generatedDemoLink);
    alert('Demo link copied to clipboard!');
  };

  const handleDemoSubmit = (event) => {
    event.preventDefault();
    const candidateName = event.target.candidateName.value;
    const candidateEmail = event.target.candidateEmail.value;
    generateDemoLink(candidateName, candidateEmail);
  };

  const handleSignInLessSubmit = (event) => {
    event.preventDefault();
    const candidateName = event.target.candidateName.value;
    const candidateEmail = event.target.candidateEmail.value;
    const numberOfQuestions = parseInt(event.target.numberOfQuestions.value, 10) || 5;
    generateSignInLessLink(candidateName, candidateEmail, numberOfQuestions);
  };

  // console.log("pppppppppppppppppppppppppp",company)
  return (
    <div>
      <Header />
      <div className="container mx-auto px-4 py-8">
        <div className="flex justify-between mb-4 gap-24">
          <h2 className="text-2xl font-bold">Job Details List</h2>
          {localStorage.getItem("CompanyEmailID") !==
            "hr@varahitechnologies.com" && (
            <h2 className="text-2xl font-bold">Current Credit: {point}</h2>
          )}
          <button
            onClick={() => {
              console.log("Buy Premium button clicked");
              setIsModalOpen(true);
              console.log(`isModalOpen`, isModalOpen);
            }}
            className="border-1 hover:bg-[#9900FF] text-white font-bold py-2 px-4 rounded capitalize"
          >
            Buy Premium
          </button>
          {/* <button
            onClick={handleProfileClickOpen}
            className="border-1 hover:bg-[#9900FF] text-white font-bold py-2 px-4 rounded capitalize"
          >
            Update Profile
          </button> */}
        </div>

        <div className="overflow-x-auto">
          <table className="w-full table-auto">
            <thead className="border-1 text-center">
              <tr className="">
                <th className="px-4 py-2">Job Title</th>
                <th className="px-4 py-2">Created At</th>
                <th className="px-4 py-2">Updated At</th>
                <th className="px-4 py-2">Actions</th>
              </tr>
            </thead>
            <tbody>
              {jobDetails.map((job) => (
                <tr key={job.id} className="border-b">
                  <td className="px-4 py-2">{job.jobTitle}</td>
                  <td className="px-4 py-2">{job.createdAt}</td>
                  <td className="px-4 py-2">{job.updatedAt}</td>                  <td className="px-4 py-2">
                    <div className="flex flex-wrap gap-2">
                      <button
                        onClick={() => handleViewDetails(job)}
                        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                      >
                        View Details
                      </button>
                      <button
                        onClick={() =>
                          navigate("/SendMail", { state: { jobId: job.id } })
                        }
                        className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded"
                      >
                        Applied Candidates
                      </button>
                      <button
                        onClick={() => handleSignInLessInterview(job)}
                        className="bg-purple-500 hover:bg-purple-700 text-white font-bold py-2 px-4 rounded"
                      >
                        Generate Interview Link
                      </button>
                      <button
                        onClick={() => handleDemoInterview(job)}
                        className="bg-orange-500 hover:bg-orange-700 text-white font-bold py-2 px-4 rounded"
                      >
                        Generate Demo Link
                      </button>
                      <button
                        onClick={() => handleDeleteJob(job.id, job.jobTitle)}
                        className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
                      >
                        Delete Job
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="flex  justify-between mx-32 p-4 gap-6">
            {/* {companyjobcount === true &&
            CompanyEmailID !== "hr@varahitechnologies.com" ? (
              <button
                onClick={() => {
                  console.log("Buy Premium button clicked");
                  setIsModalOpen(true);
                  console.log(`isModalOpen`, isModalOpen);
                }}
                className="border-1 hover:bg-[#9900FF] text-white font-bold py-2 px-4 rounded capitalize"
              >
                Buy Premium
              </button>
            ) : ( */}
            <Link to={"/JobDetails"}>
              <button className="border-1 hover:bg-[#9900FF] text-white font-bold py-2 px-4 rounded capitalize">
                add Job description
              </button>
            </Link>
            {/* )} */}
            <button
              onClick={handleStandaloneDemoInterview}
              className="border-1 hover:bg-orange-600 bg-orange-500 text-white font-bold py-2 px-4 rounded"
            >
              🧪 Quick Demo (Mock JD)
            </button>
            <Link to={"/SendMail"}>
              <button className="border-1 hover:bg-[#9900FF] text-white font-bold py-2 px-4 rounded">
                Private candidate
              </button>
            </Link>
          </div>
        </div>
        {isModalOpen && <BuyPremium closeModal={closeModal} />}
        {}
        {showModal && selectedJob && (
          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-center justify-center min-h-screen">
              <div className="bg-black rounded-lg shadow-lg p-8">
                <button
                  onClick={handleCloseModal}
                  className="absolute top-0 right-0 mt-4 mr-4 bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
                >
                  X
                </button>

                {isEditMode ? (
                  <JobPostForm
                    initialValues={selectedJob}
                    onCancel={handleCloseModal}
                  />
                ) : (
                  <>
                    <JobPostDetails jobDetails={selectedJob} />
                    <div className="mt-4 flex justify-between">
                      <button
                        onClick={handleCloseModal}
                        className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded"
                      >
                        Close
                      </button>
                      <div>
                        <button
                          onClick={handleEditJob}
                          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                        >
                          Edit
                        </button>
                        {/* send Private screeing mail */}
                        <button
                          onClick={handlePrivateScreeningMail}
                          className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded ml-2"
                        >
                          Private screening mail
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        )}
        {showPrivateScreeningModal && (
          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-center justify-center min-h-screen">
              <div className="bg-white rounded-lg shadow-lg p-8">
                <h2 className="text-2xl font-bold mb-4 text-black">
                  Private Screening Mail
                </h2>
                <form onSubmit={handlePrivateScreeningMailSubmit}>
                  <div className="mb-4">
                    <label
                      htmlFor="candidateName"
                      className="block text-gray-700 font-bold mb-2"
                    >
                      Candidate Name
                    </label>
                    <input
                      type="text"
                      id="candidateName"
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                      required
                    />
                  </div>
                  <div className="mb-4">
                    <label
                      htmlFor="candidateEmail"
                      className="block text-gray-700 font-bold mb-2"
                    >
                      Candidate Email
                    </label>
                    <input
                      type="email"
                      id="candidateEmail"
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                      required
                    />
                  </div>
                  {/* <div className="mb-4">
                  <label
                    htmlFor="jobDescription"
                    className="block text-gray-700 font-bold mb-2"
                  >
                    Job Description
                  </label>
                  <textarea
                    id="jobDescription"
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    rows="5"
                    required
                  ></textarea>
                </div> */}
                  <div className="flex justify-end">
                    <button
                      type="submit"
                      className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                      disabled={isSending}
                    >
                      {isSending ? "Sending..." : "Send Mail"}
                    </button>
                    <button
                      onClick={handleCloseModal}
                      className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded ml-4"
                    >
                      Close
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>        )}

        {/* Sign-in-less interview link generation modal */}
        {showSignInLessModal && (
          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-center justify-center min-h-screen">
              <div className="bg-white rounded-lg shadow-lg p-8">
                <h2 className="text-2xl font-bold mb-4 text-black">
                  Generate Sign-in-less Interview Link
                </h2>
                <p className="text-gray-600 mb-4">
                  Job: {selectedJob?.jobTitle}
                </p>
                <form onSubmit={handleSignInLessSubmit}>
                  <div className="mb-4">
                    <label
                      htmlFor="candidateName"
                      className="block text-gray-700 font-bold mb-2"
                    >
                      Candidate Name
                    </label>
                    <input
                      type="text"
                      id="candidateName"
                      name="candidateName"
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                      required
                    />
                  </div>
                  <div className="mb-4">
                    <label
                      htmlFor="candidateEmail"
                      className="block text-gray-700 font-bold mb-2"
                    >
                      Candidate Email
                    </label>
                    <input
                      type="email"
                      id="candidateEmail"
                      name="candidateEmail"
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                      required
                    />
                  </div>
                  <div className="mb-4">
                    <label
                      htmlFor="numberOfQuestions"
                      className="block text-gray-700 font-bold mb-2"
                    >
                      Number of Questions
                    </label>
                    <select
                      id="numberOfQuestions"
                      name="numberOfQuestions"
                      defaultValue="5"
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    >
                      <option value="3">3 questions (~9 minutes)</option>
                      <option value="5">5 questions (~15 minutes)</option>
                      <option value="8">8 questions (~24 minutes)</option>
                      <option value="10">10 questions (~30 minutes)</option>
                      <option value="15">15 questions (~45 minutes)</option>
                    </select>
                  </div>
                  {linkGenerationError && (
                    <div className="mb-4 text-red-500">
                      {linkGenerationError}
                    </div>
                  )}
                  <div className="flex justify-end">
                    <button
                      type="submit"
                      className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                      disabled={isGeneratingLink}
                    >
                      {isGeneratingLink ? "Generating..." : "Generate Link"}
                    </button>
                    <button
                      type="button"
                      onClick={closeSignInLessModal}
                      className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded ml-4"
                    >
                      Close
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}

        {/* Demo interview link generation modal */}
        {showDemoModal && (
          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-center justify-center min-h-screen">
              <div className="bg-white rounded-lg shadow-lg p-8 max-w-lg w-full max-h-[90vh] overflow-y-auto">
                <h2 className="text-2xl font-bold mb-4 text-black">
                  🎯 Generate Demo Interview Link
                </h2>
                <p className="text-orange-600 mb-4 text-sm font-medium">
                  ⚡ Demo Features: 4 questions, 12 minutes, no recording
                </p>
                <form onSubmit={handleDemoSubmit}>
                  {/* 🧪 Mock JD Selector for Testing */}
                  <div className="mb-4">
                    <label
                      htmlFor="mockJDSelector"
                      className="block text-gray-700 font-bold mb-2"
                    >
                      🧪 Select Job Description (for testing)
                    </label>
                    <select
                      id="mockJDSelector"
                      name="mockJDSelector"
                      value={selectedMockJD?.id || selectedJob?.id || ''}
                      onChange={(e) => {
                        const selectedId = e.target.value;
                        if (selectedId === 'real-job' && selectedJob) {
                          setSelectedMockJD(null);
                        } else {
                          const mockJD = MOCK_JOB_DESCRIPTIONS.find(jd => jd.id === selectedId);
                          setSelectedMockJD(mockJD || null);
                        }
                      }}
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    >
                      {selectedJob && (
                        <option value="real-job">📁 Current Job: {selectedJob.jobTitle}</option>
                      )}
                      <optgroup label="🧪 Mock Job Descriptions">
                        {MOCK_JOB_DESCRIPTIONS.map((jd) => (
                          <option key={jd.id} value={jd.id}>
                            {jd.jobTitle} ({jd.selectedExperience})
                          </option>
                        ))}
                      </optgroup>
                    </select>
                  </div>

                  {/* Show selected JD details */}
                  {(selectedMockJD || selectedJob) && (
                    <div className="mb-4 bg-blue-50 border border-blue-200 rounded p-3">
                      <p className="text-sm text-blue-800">
                        <span className="font-semibold">📋 Selected JD: {(selectedMockJD || selectedJob)?.jobTitle}</span><br/>
                        <span className="text-xs">
                          <strong>Category:</strong> {(selectedMockJD || selectedJob)?.selectedCategory || 'N/A'}<br/>
                          <strong>Experience:</strong> {(selectedMockJD || selectedJob)?.selectedExperience || 'N/A'}<br/>
                          <strong>Skills:</strong> {((selectedMockJD || selectedJob)?.skill || 'N/A').substring(0, 80)}...
                        </span>
                      </p>
                    </div>
                  )}

                  <div className="mb-4">
                    <label
                      htmlFor="demoCandidateName"
                      className="block text-gray-700 font-bold mb-2"
                    >
                      Candidate Name <span className="text-gray-400 font-normal">(optional)</span>
                    </label>
                    <input
                      type="text"
                      id="demoCandidateName"
                      name="candidateName"
                      placeholder="Demo Candidate"
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    />
                  </div>
                  <div className="mb-4">
                    <label
                      htmlFor="demoCandidateEmail"
                      className="block text-gray-700 font-bold mb-2"
                    >
                      Candidate Email <span className="text-gray-400 font-normal">(optional)</span>
                    </label>
                    <input
                      type="email"
                      id="demoCandidateEmail"
                      name="candidateEmail"
                      placeholder="demo@example.com"
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    />
                  </div>
                  <div className="mb-4">
                    <div className="bg-orange-50 border border-orange-200 rounded p-3">
                      <p className="text-sm text-orange-800">
                        <span className="font-semibold">Demo Configuration:</span><br/>
                        • Fixed at 4 questions (~12 minutes)<br/>
                        • No video/audio recording<br/>
                        • Job context sent to AI for relevant questions<br/>
                        • <span className="text-orange-600">Name & email are optional for quick testing</span>
                      </p>
                    </div>
                  </div>
                  {demoLinkGenerationError && (
                    <div className="mb-4 text-red-500">
                      {demoLinkGenerationError}
                    </div>
                  )}
                  <div className="flex justify-end">
                    <button
                      type="submit"
                      className="bg-orange-500 hover:bg-orange-700 text-white font-bold py-2 px-4 rounded"
                      disabled={isGeneratingDemoLink}
                    >
                      {isGeneratingDemoLink ? "Generating..." : "Generate Demo Link"}
                    </button>
                    <button
                      type="button"
                      onClick={closeDemoModal}
                      className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded ml-4"
                    >
                      Close
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}

        {/* Generated demo link display modal */}
        {showDemoLinkModal && (
          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-center justify-center min-h-screen">
              <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full">
                <h2 className="text-2xl font-bold mb-4 text-black">
                  🎯 Demo Interview Link Generated!
                </h2>
                <p className="text-gray-600 mb-4">
                  Share this demo link with the candidate:
                </p>
                <div className="mb-4">
                  <label className="block text-gray-700 font-bold mb-2">
                    Generated Demo Link
                  </label>
                  <div className="flex">
                    <input
                      type="text"
                      value={generatedDemoLink}
                      readOnly
                      className="shadow appearance-none border rounded-l w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    />
                    <button
                      onClick={copyDemoLinkToClipboard}
                      className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded-r"
                    >
                      Copy
                    </button>
                  </div>
                </div>
                <div className="text-sm text-gray-500 mb-4">
                  <p>🎯 <strong>Demo Features:</strong></p>
                  <p>• 4 questions, ~12 minute interview</p>
                  <p>• No video/audio recording</p>
                  <p>• Perfect for platform demonstration</p>
                  <p>• Single-use link (expires after completion)</p>
                </div>
                <div className="flex justify-end">
                  <button
                    onClick={closeDemoLinkModal}
                    className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Generated link display modal */}
        {showLinkModal && (
          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-center justify-center min-h-screen">
              <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full">
                <h2 className="text-2xl font-bold mb-4 text-black">
                  Interview Link Generated Successfully!
                </h2>
                <p className="text-gray-600 mb-4">
                  Share this link with the candidate for sign-in-less interview access:
                </p>
                <div className="mb-4">
                  <label className="block text-gray-700 font-bold mb-2">
                    Generated Link
                  </label>
                  <div className="flex">
                    <input
                      type="text"
                      value={generatedLink}
                      readOnly
                      className="shadow appearance-none border rounded-l w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    />
                    <button
                      onClick={copyLinkToClipboard}
                      className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded-r"
                    >
                      Copy
                    </button>
                  </div>
                </div>
                <div className="text-sm text-gray-500 mb-4">
                  <p>• This link is single-use and will expire after the interview is completed</p>
                  <p>• No sign-in required for the candidate</p>
                  <p>• The candidate can access the interview directly using this link</p>
                </div>
                <div className="flex justify-end">
                  <button
                    onClick={closeLinkModal}
                    className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default JobDetailsList;
